<template>
  <section class="protocol_detail_section">
    <h3 class="tit" ref="title" data-depth="0">
      <span>용어설명</span>
      <span v-if="readonly === false">
        <button class="editContent" v-show="!isActive" @click.stop="editorActive">편집</button>
        <button v-show="isActive" class="editContent" @click.stop="closeEditor">저장하기</button>
      </span>
    </h3>
    <div class="editorArea">
        <div v-show="!isActive" ref="namo" id="namoKeywordEditor" v-html="contentText" @click.stop="editorActive"></div>
        <div v-if="readonly === false" v-show="isActive" class="namoArea" :is="NamoEditor" :content="contentText" @ready="(editor)=> readyNamoEditor(editor)"></div>
    </div>
  </section>
</template>
<script>
import NamoWebEditor from './wikiNamo.vue';
import CommNew, {commNewMapMutations, commNewMapGetters, typeOfJson} from "@processEditor/CommNew";

const defaultTable = `
  <table cellspacing="0" cellpadding="0" border="1" style="width: 1120px; height: 90px; font-size: 10pt; border-width: 0px; border-color: rgb(221, 221, 221); border-collapse: collapse; border-style: solid; background-color: rgb(255, 255, 255);"> 
    <tbody> 
      <tr> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid; background-color: rgb(245, 245, 245);"><p style="text-align: center;">한글명칭</p></td> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid; background-color: rgb(245, 245, 245);"><p style="text-align: center;">영문명칭</p></td> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid; background-color: rgb(245, 245, 245);"><p style="text-align: center;">설명</p></td> 
      </tr> 
      <tr> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td>
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td>
      </tr>
      <tr> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td>
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td>
      </tr>
    </tbody> 
  </table>
`

export default {
  async beforeDestroy () {
    this.textEditor = null;
	} ,
  name:'wikiKeyword',
  props: {
    item: { type: Object, default: {} },
    readonly: {
      type: Boolean,
      default: false
    },
    editorSelect: Function,
    deactivate: Function,
  },
  
  mixins: [CommNew],
  data(){
    return {
      isActive: false,
      NamoEditor: null,
      contentText: '',
      textEditor: null
    }
  },
  components: {NamoWebEditor},
  updated() {
    this.$emit('updated', {
			title : this.$refs.title,
			key: this.item.key || null,
			depth : 0,
      type: 'keyword'
		})
  },
  async mounted() {
    // const res = await this.$wApi.protocol.protocolContent.get({
    //   protocolId: this.item.protocolId, 
    //   tagKey: this.item.key
    // });
    //
    // if(!res.content || res.content == '' || res.content == "\"<p><br></p>\"") {
    //   this.contentText = defaultTable;
    // } else {
    //   this.contentText = JSON.parse(res.content);
    // }
    // this.$emit('load-content', true);
  },
  methods: {
    editorActive() {
      if(this.isActive === false) {
        this.NamoEditor = 'NamoWebEditor';
      } 
    },
    editorFocusOut() {
			this.closeEditor = (e) => {
				e.stopPropagation();
				this.isActive = false;
        window.removeEventListener( 'click', this.closeEditor );
        if(this.textEditor) {
          this.deactiveEditor(this.editor);
				  this.deactivate(this.textEditor);
        }
			}
			window.addEventListener('click', this.closeEditor );
		},
    deactiveEditor() {
      if(!this.textEditor) {
        this.NamoEditor = null;
        return;
      } 
      let textValue = this.textEditor.GetBodyValue();
      this.contentText = textValue.replace(/font-family\s*:\s*([^;]+);/gi, '');
      this.NamoEditor = null;
    },
    readyNamoEditor(editor) {
			this.textEditor = editor;
			this.textEditor.getContent = this.textEditor.GetBodyValue;
      this.textEditor.closeEditor = this.closeEditor;
			this.editorSelect( this.item, this.textEditor, {
				getContent : this.textEditor.GetBodyValue
			});
			this.editorFocusOut();
			this.isActive = true;
		},
  }
}
</script>
<style lang="scss" scoped>
@import './wikiContent.scss';
</style>